import clsx from 'clsx';
import { ComponentProps, forwardRef } from 'react';

import styles from './Flex.module.scss';

export type FlexProps = ComponentProps<'div'> & {
  direction?: 'row' | 'rowReverse' | 'column' | 'columnReverse';
  justifyContent?: 'center' | 'flexStart' | 'flexEnd' | 'spaceBetween' | 'spaceEvenly' | 'spaceAround';
  alignItems?: 'center' | 'flexStart' | 'flexEnd' | 'stretch' | 'baseline';
  wrap?: 'wrap' | 'nowrap';
  gap?: number;
  inline?: boolean;
  childMinSize?: '0' | 'unset';
};

export const Flex = forwardRef<HTMLDivElement, FlexProps>((props, ref) => {
  const {
    className,
    children,
    style,
    direction = 'row',
    justifyContent,
    alignItems,
    wrap,
    gap,
    inline,
    childMinSize = '0',
    ...restProps
  } = props;

  return (
    <div
      className={clsx(
        styles.root,
        inline && styles.inline,
        direction && styles[`direction_${direction}`],
        justifyContent && styles[`justifyContent_${justifyContent}`],
        alignItems && styles[`alignItems_${alignItems}`],
        wrap && styles[`wrap_${wrap}`],
        childMinSize !== 'unset' && styles[`childMinSize_${childMinSize}`],
        className
      )}
      ref={ref}
      style={{
        gap: typeof gap === 'number' ? gap * 4 : undefined,
        ...style,
      }}
      {...restProps}
    >
      {children}
    </div>
  );
});

Flex.displayName = 'Flex';
